// Transform block tree state variables to block server api
const BlockActionVariableTransformer = (origin) => {

    const data = { ...origin };

    data.variables = data.variables.map( (variable) => { return { variable_name : variable.variable == null ? null :  variable.variable.name, variable_value : variable.value, is_operation : variable.is_operation, index : variable.index}})
    
    return data
}

export default BlockActionVariableTransformer;